﻿import React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeGrid } from "react-window";
import styled from "styled-components";
import { Scrollable } from "../";
import { BODY } from "../Fonts";
import { IColumn, IRowWithIndexAndSelected } from "./Table";
import { TableBodyCell } from "./TableBodyCell";

const BodyContainer = styled.div`
    flex: 1;
    font: ${BODY};
    cursor: ${(props) => (props.theme.selectable ? "pointer" : "unset")};
`;

interface ITableBodyProps {
    /* Table columns */
    columns: IColumn[];

    /* Table rows */
    rows: IRowWithIndexAndSelected[];

    /* On horizontal scroll */
    onHScroll: (scrollLeft: number) => void;

    /* Whether rows are selectable */
    selectable?: boolean;

    /* Index of selected row */
    selectedRow?: number;

    /* Handler on row click */
    onRowClick?: (rowIndex) => void;

    /* Ref to VariableSizeGrid */
    tableRef: React.MutableRefObject<VariableSizeGrid>;
}

const CustomScrollbars = React.forwardRef((outerElementProps: any, ref: any) => {

    return (
        <div className='scroll' style={outerElementProps.style} onScroll={outerElementProps.onScroll}>
            {outerElementProps.children}
        </div>
    );
});


export const TableBody: React.FunctionComponent<ITableBodyProps> = (props) => {
    const [hoverIndex, setHoverIndex] = React.useState(-1);

    const onRowClick = (rowIndex) => {
        if (props.onRowClick) {
            props.onRowClick(rowIndex);
        }
    };

    const cellGetter = ({ columnIndex, rowIndex, style }) => {
        return (
            <TableBodyCell
                style={style}
                column={props.columns[columnIndex]}
                row={props.rows[rowIndex].row}
                selected={rowIndex === props.selectedRow}
                hover={rowIndex === hoverIndex && props.selectable}
                onClick={() => onRowClick(props.rows[rowIndex].index)}
                onHover={() => setHoverIndex(rowIndex)}
            />
        );
    };

    return (
        <BodyContainer className='scroll' onMouseLeave={() => setHoverIndex(-1)} theme={{ selectable: props.selectable }}>
        <AutoSizer>
            {({ height, width }) => (
                 <VariableSizeGrid
                    ref={props.tableRef}
                    height={height}
                    width={width}
                    rowCount={props.rows ? props.rows.length : 0}
                    rowHeight={i => 30}
                    columnCount={props.columns ? props.columns.length : 0}
                    columnWidth={i => props.columns[i].width+20}
                    onScroll={({ scrollLeft }) => props.onHScroll(scrollLeft)}
                    outerElementType={CustomScrollbars}>
                    {cellGetter}
                </VariableSizeGrid>
            )}
        </AutoSizer>
    </BodyContainer>);
}